<template>
  <AppTop msg="NORISAPP, Top page"/>
</template>

<script>
import AppTop from './components/AppTop.vue'

export default {
  name: 'App',
  components: {
    AppTop
  }
}
</script>

<style>
/*
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
*/
</style>
